import { atom } from 'jotai';
import Customer from '../service/types/Customer';

export const allCustomersAtom = atom<Customer[]>([]);
